import React, { useState } from "react";
import { logsToCsv,downloadCsvFile } from "../../../helpers/csvUtils";

const ExportCsvButton = ({
                           logs = [],
                           headers = [],
                           keys = [],
                           fileName = "logs.csv",
                           buttonText = "Export as CSV",
                         }) => {
  const [downloadFeedback, setDownloadFeedback] = useState(false);

  const handleExport = () => {
    const csvString = logsToCsv(logs, headers, keys);
    
    // Trigger the download and set feedback via a callback
    downloadCsvFile(csvString, fileName, () => {
      setDownloadFeedback(true);
      // Hide feedback after 3 seconds
      setTimeout(() => setDownloadFeedback(false), 3000);
    });
  };

  return (
      <div>
        <button onClick={handleExport} style={styles.button} disabled={!logs.length}>
          {buttonText}
        </button>
        {downloadFeedback && (
            <div style={styles.feedback}>
              File download initiated successfully.
            </div>
        )}
      </div>
  );
};

const styles = {
  button: {
    color: "white",
    backgroundColor: "#28a745",
    padding: "8px 12px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  feedback: {
    marginTop: "10px",
    color: "green",
    fontWeight: "bold",
  },
};

export default ExportCsvButton;
